import { ValueFormatterParams, ValueSetterParams } from "ag-grid-community";

import { HensColDef } from "lib/frontend/cm/utils/types";

import { HydratedFieldDefinition, UsageModel } from "../../fieldDefinition";
import { FieldModelType, FieldBaseModelMap } from "../../types";

export function toAgGridColumnDefinition<
  M extends UsageModel = UsageModel,
  T extends FieldModelType = FieldBaseModelMap[M],
>(field: HydratedFieldDefinition<M, T>): HensColDef {
  let comparator: HensColDef["comparator"] = undefined;
  const fieldComparator = field.comparator;
  if (fieldComparator) {
    comparator = (value1, value2, node1, node2) => {
      return fieldComparator?.(value1, value2, node1?.data, node2?.data, field.context);
    };
  }

  let colDef: HensColDef = {
    ...field.agGridSettings,
    filterParams: {
      // valueFormatter: (params) => {
      //   if (_.isNil(params.value) && _.isNil(params.data)) {
      //     console.log("neither");
      //     console.log(params);

      //     return null;
      //   } else if (_.isNil(params.value) && !_.isNil(params.data)) {
      //     return field.getFormattedValue(params.data);
      //   } else {
      //     return params.value;
      //   }
      // },
      ...field.agGridSettings?.filterParams,
    },
    colId: field.id,
    valueGetter: (params) => {
      return field.getValue(params.data);
    },
    valueFormatter: (params) => {
      return field.getFormattedValue(params.data);
    },

    comparator: comparator,
  };

  const fieldValueSetter = field.valueSetter;
  if (fieldValueSetter) {
    colDef.valueSetter = (params: ValueSetterParams<T>) => {
      return fieldValueSetter({
        newValue: params.newValue,
        instance: params.data as T,
        context: field.context,
      });
    };
  }

  const fieldExportFormatter = field.exportFormatter;
  if (fieldExportFormatter) {
    colDef.cellExportFormatter = (params: ValueFormatterParams<T>) => {
      return fieldExportFormatter({
        value: params.value,
        instance: params.node?.data as T,
        context: field.context,
      });
    };
  }

  if (field.label) {
    colDef.headerName = field.label;
  }

  colDef.headerComponentParams = {
    ...colDef.headerComponentParams,
    innerHeaderComponent: "defaultCustomHeaderComponent",
    innerHeaderComponentParams: {
      ...colDef.headerComponentParams?.innerHeaderComponentParams,
    },
  };

  if (field.description) {
    colDef.headerTooltip = field.description;
    colDef.tooltipComponent = "tooltipHeader";
    // this is now handled by the header inner component
    // colDef.headerClass = "tooltip-header-underline";
  }

  return colDef;
}
